
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';

interface PersonalitySelectorProps {
  selectedPersonality: string;
  onPersonalityChange: (personality: string) => void;
}

const personalities = [
  { value: 'sage', label: 'Sage' },
  { value: 'shimmer', label: 'Shimmer' },
  { value: 'nova', label: 'Nova' },
  { value: 'onyx', label: 'Onyx' }
];

const PersonalitySelector = ({ selectedPersonality, onPersonalityChange }: PersonalitySelectorProps) => {
  return (
    <div className="mb-6 space-y-2">
      <Label htmlFor="personality-select" className="text-foreground font-medium">
        Voice Personality
      </Label>
      <Select value={selectedPersonality} onValueChange={onPersonalityChange}>
        <SelectTrigger id="personality-select" className="bg-background border-border text-foreground">
          <SelectValue placeholder="Select a personality" />
        </SelectTrigger>
        <SelectContent>
          {personalities.map((personality) => (
            <SelectItem 
              key={personality.value} 
              value={personality.value}
            >
              {personality.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default PersonalitySelector;
